import React, { Fragment } from 'react';
import * as runtime from 'react/jsx-runtime.js';
import * as provider from '@mdx-js/react';
import { MDXProvider } from '@mdx-js/react';
import { compileSync, runSync } from '@mdx-js/mdx';
import { InterSitial, Link, PhoneLink, RichText } from '..';
import useProduct from '../../../../hooks/useProduct';

const MDXRenderer: React.FC<{
	children: string;
	shortcodes?: { [key: string]: JSX.Element | React.FC };
}> = ({ children, shortcodes = {} }) => {
	const { params } = useProduct();

	const compiled = compileSync(children, {
		outputFormat: 'function-body',
		providerImportSource: '@mdx-js/react',
	});
	const mdxModule = runSync(String(compiled), { ...provider, ...runtime });
	const Content = mdxModule ? mdxModule.default : Fragment;

	// Inject the components commonly used on MDX via MDXProvider
	// Needed until imports work properly for MDX parsed by this component
	return (
		<MDXProvider components={{ RichText, InterSitial, Link, PhoneLink, ...shortcodes }}>
			<Content params={params} />
		</MDXProvider>
	);
};

export default MDXRenderer;
